import React, { FC } from 'react';
import { Icon, IconProps } from '../Icon';

export const Circle: FC<IconProps> = (props) => (
  <Icon {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16 27.5c-6.065 0-11-4.935-11-11s4.935-11 11-11 11 4.935 11 11-4.935 11-11 11Zm0-24c-7.168 0-13 5.832-13 13s5.832 13 13 13 13-5.832 13-13-5.832-13-13-13Z"
      clipRule="evenodd"
    />
  </Icon>
);
